/* THE SIGN — product.js
   Karta produktu: galeria (miniatury + zoom), wybór wariantu (kolor
   pigułkami, rozmiar selectem z dostępnością), stepper ilości,
   aktualizacja SKU/EAN/ceny/dostępności, zakładki treści. */
(function () {
  'use strict';

  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var mapEl = section.querySelector('[data-variant-map]');
    if (!mapEl) return;

    var variants = JSON.parse(mapEl.textContent);
    var dash = '—';

    /* ------------------------------------------------------------------
       Galeria: przełączanie miniaturek + zoom podążający za kursorem.
       ------------------------------------------------------------------ */
    var gallery = section.querySelector('[data-product-gallery]');
    var items = [];
    var thumbs = [];
    if (gallery) {
      items = gallery.querySelectorAll('[data-gallery-item]');
      thumbs = gallery.querySelectorAll('[data-gallery-thumb]');

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var id = thumb.getAttribute('data-gallery-thumb');
          items.forEach(function (item) {
            item.hidden = item.getAttribute('data-gallery-item') !== id;
          });
          thumbs.forEach(function (t) {
            var active = t === thumb;
            t.classList.toggle('is-active', active);
            if (active) {
              t.setAttribute('aria-current', 'true');
            } else {
              t.removeAttribute('aria-current');
            }
          });
        });
      });

      if (gallery.hasAttribute('data-zoom')) {
        var stage = gallery.querySelector('[data-gallery-stage]');
        if (stage) {
          stage.addEventListener('mousemove', function (e) {
            var rect = stage.getBoundingClientRect();
            var x = ((e.clientX - rect.left) / rect.width) * 100;
            var y = ((e.clientY - rect.top) / rect.height) * 100;
            stage.style.setProperty('--zoom-x', x.toFixed(2) + '%');
            stage.style.setProperty('--zoom-y', y.toFixed(2) + '%');
          });
        }
      }
    }

    /* Przełącza główne zdjęcie galerii na wskazane media_id
       (używane też przy zmianie koloru pigułką). */
    function showMedia(mediaId) {
      if (!mediaId) return;
      var id = String(mediaId);
      items.forEach(function (item) {
        item.hidden = item.getAttribute('data-gallery-item') !== id;
      });
      thumbs.forEach(function (t) {
        var active = t.getAttribute('data-gallery-thumb') === id;
        t.classList.toggle('is-active', active);
        if (active) {
          t.setAttribute('aria-current', 'true');
        } else {
          t.removeAttribute('aria-current');
        }
      });
    }

    /* ------------------------------------------------------------------
       Meta: SKU / EAN / cena / dostępność.
       ------------------------------------------------------------------ */
    var skuEl = section.querySelector('[data-sku]');
    var eanEl = section.querySelector('[data-ean]');
    var priceEl = section.querySelector('[data-price-value]');
    var nettoEl = section.querySelector('[data-price-netto]');
    var availEl = section.querySelector('[data-availability]');
    var pricePrefix = section.getAttribute('data-price-prefix') || '';
    var txtInStock = section.getAttribute('data-text-in-stock') || '';
    var txtOutStock = section.getAttribute('data-text-out-stock') || '';

    function setAvailability(available) {
      if (!availEl) return;
      availEl.textContent = available ? txtInStock : txtOutStock;
      availEl.classList.toggle('badge--success', available);
      availEl.classList.toggle('badge--warning', !available);
    }

    function setVariant(v) {
      if (!v) return;
      if (skuEl) skuEl.textContent = v.sku || dash;
      if (eanEl) eanEl.textContent = v.barcode || dash;
      if (priceEl) priceEl.textContent = v.price;
      if (nettoEl) nettoEl.textContent = v.price_netto || '';
      setAvailability(v.available);
    }

    /* ------------------------------------------------------------------
       Wybór wariantu (≤2 osie opcji): kolor pigułkami, rozmiar selectem
       z adnotacją dostępności; formularz zakupu podąża za wyborem.
       ------------------------------------------------------------------ */
    var matrix = section.querySelector('[data-variant-matrix]');
    if (matrix) {
      var twoAxes = matrix.getAttribute('data-axes') === '2';
      var sizesEl = matrix.querySelector('[data-size-values]');
      var sizes = sizesEl ? JSON.parse(sizesEl.textContent) : [];
      var selectedColorEl = matrix.querySelector('[data-selected-color]');
      var sizeSelect = matrix.querySelector('[data-size-select]');
      var sizePills = matrix.querySelectorAll('[data-size-pill]');
      var pills = matrix.querySelectorAll('[data-color-pill]');
      var quoteBtn = section.querySelector('[data-quote-open]');

      function findVariant(color, size) {
        for (var id in variants) {
          var v = variants[id];
          if (twoAxes) {
            if (v.option1 === color && v.option2 === size) return v;
          } else if (v.option1 === size) {
            return v;
          }
        }
        return null;
      }

      function currentColor() {
        return selectedColorEl ? selectedColorEl.textContent : null;
      }

      /* Tytuł przekazywany do modala wyceny: produkt — kolor / rozmiar. */
      function updateQuoteTitle(color, size) {
        if (!quoteBtn) return;
        var base =
          quoteBtn.getAttribute('data-product-base') ||
          quoteBtn.getAttribute('data-product-title') ||
          '';
        quoteBtn.setAttribute('data-product-base', base);
        var title = base;
        if (color) title += ' — ' + color;
        if (size) title += ' / ' + size;
        quoteBtn.setAttribute('data-product-title', title);
      }

      /* Select rozmiaru: opcje niedostępne dostają dopisek „— brak w
         magazynie" i są wyłączone; wybór przeskakuje na pierwszy dostępny.
         Tryb sklep: synchronizacja ukrytego pola id wariantu i przycisku
         „Dodaj do koszyka". */
      var idInput = matrix.querySelector('[data-variant-id-input]');
      var matrixAddBtn = matrix.querySelector('[data-add-button]');

      function syncSelection(color) {
        var selected = findVariant(color, sizeSelect.value);
        if (selected) setVariant(selected);
        if (idInput) idInput.value = selected ? selected.id : '';
        if (matrixAddBtn) matrixAddBtn.disabled = !selected || !selected.available;
        updateQuoteTitle(color, sizeSelect.value);
      }

      function renderSizeOptions(color) {
        if (!sizeSelect) return;
        var prev = sizeSelect.value;
        sizeSelect.innerHTML = '';
        var firstAvailable = null;
        sizes.forEach(function (size) {
          var v = findVariant(color, size);
          var opt = document.createElement('option');
          opt.value = size;
          opt.textContent = size;
          if (!v || !v.available) {
            opt.textContent = size + ' — ' + txtOutStock;
            opt.disabled = true;
          } else if (!firstAvailable) {
            firstAvailable = size;
          }
          sizeSelect.appendChild(opt);
        });
        var keep = false;
        Array.prototype.forEach.call(sizeSelect.options, function (opt) {
          if (opt.value === prev && !opt.disabled) keep = true;
        });
        sizeSelect.value = keep ? prev : firstAvailable || prev;
        /* Pigułki rozmiarów podążają za selectem: dostępność + stan aktywny. */
        Array.prototype.forEach.call(sizeSelect.options, function (opt) {
          var pill = matrix.querySelector('[data-size-pill="' + CSS.escape(opt.value) + '"]');
          if (!pill) return;
          pill.disabled = opt.disabled;
          if (opt.disabled) pill.title = opt.value + ' — ' + txtOutStock;
          else pill.removeAttribute('title');
          var active = opt.value === sizeSelect.value && !opt.disabled;
          pill.classList.toggle('is-active', active);
          pill.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        syncSelection(color);
      }

      function updateForColor(color) {
        var first = null;
        var minV = null;
        var varies = false;

        sizes.forEach(function (size) {
          var v = findVariant(color, size);
          if (!v) return;
          if (!first) first = v;
          if (!minV || v.price_amount < minV.price_amount) minV = v;
        });

        var shown = sizeSelect && sizeSelect.value
          ? findVariant(color, sizeSelect.value) || first
          : first;
        if (shown) {
          if (skuEl) skuEl.textContent = shown.sku || dash;
          if (eanEl) eanEl.textContent = shown.barcode || dash;
          if (shown.media_id) showMedia(shown.media_id); // zdjęcie wybranego koloru
        }

        if (priceEl && minV) {
          for (var id in variants) {
            var v = variants[id];
            if (v.option1 === color && v.price_amount !== minV.price_amount) {
              varies = true;
              break;
            }
          }
          priceEl.textContent = (varies ? pricePrefix : '') + minV.price;
          if (nettoEl) nettoEl.textContent = (varies ? pricePrefix : '') + (minV.price_netto || '');
        }

        updateQuoteTitle(color, sizeSelect ? sizeSelect.value : null);
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) {
            p.classList.toggle('is-active', p === pill);
            p.setAttribute('aria-pressed', p === pill ? 'true' : 'false');
          });
          var color = pill.getAttribute('data-color-pill');
          if (selectedColorEl) selectedColorEl.textContent = color;
          if (sizeSelect) {
            renderSizeOptions(color);
          }
          updateForColor(color);
        });
      });

      if (sizeSelect) {
        sizeSelect.addEventListener('change', function () {
          var color = currentColor();
          var v = findVariant(color, sizeSelect.value);
          if (v && v.media_id) showMedia(v.media_id);
          syncSelection(color);
        });
        /* Pigułki rozmiaru ustawiają select i odpalają tę samą ścieżkę co zmiana. */
        sizePills.forEach(function (pill) {
          pill.addEventListener('click', function () {
            if (pill.disabled) return;
            sizeSelect.value = pill.getAttribute('data-size-pill');
            sizePills.forEach(function (p) {
              var active = p === pill;
              p.classList.toggle('is-active', active);
              p.setAttribute('aria-pressed', active ? 'true' : 'false');
            });
            sizeSelect.dispatchEvent(new Event('change'));
          });
        });
        /* Stan początkowy: SKU/EAN, cena i formularz pod wybrany rozmiar. */
        renderSizeOptions(currentColor());
      }
    }

    /* ------------------------------------------------------------------
       Stepper ilości: przyciski −/+ przy polu number.
       ------------------------------------------------------------------ */
    section.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
      var input = stepper.querySelector('input');
      if (!input) return;
      stepper.querySelectorAll('[data-qty-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = parseInt(btn.getAttribute('data-qty-step'), 10) || 0;
          var min = parseInt(input.min, 10) || 1;
          var next = (parseInt(input.value, 10) || 0) + delta;
          input.value = Math.max(min, next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    /* ------------------------------------------------------------------
       Wariant prosty: select ze wszystkimi wariantami (>2 osie opcji).
       ------------------------------------------------------------------ */
    var select = section.querySelector('[data-variant-select]');
    if (select) {
      var addBtn = section.querySelector('[data-add-button]');
      select.addEventListener('change', function () {
        var v = variants[select.value];
        if (!v) return;
        setVariant(v);
        if (addBtn) addBtn.disabled = !v.available;
      });
    }

    /* ------------------------------------------------------------------
       Zakładki treści pod kartą (Opis / Dane techniczne / …) — panele
       podmieniają się w miejscu, strona się nie przesuwa.
       ------------------------------------------------------------------ */
    var tabsBox = section.querySelector('[data-product-tabs]');
    if (tabsBox) {
      var tabs = Array.prototype.slice.call(tabsBox.querySelectorAll('[data-tab]'));
      var panels = Array.prototype.slice.call(tabsBox.querySelectorAll('[data-panel]'));

      function activateTab(tab, focus) {
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        var key = tab.getAttribute('data-tab');
        panels.forEach(function (p) {
          p.hidden = p.getAttribute('data-panel') !== key;
        });
        if (focus) tab.focus();
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () {
          activateTab(tab, false);
        });
        tab.addEventListener('keydown', function (e) {
          var delta = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!delta) return;
          e.preventDefault();
          activateTab(tabs[(i + delta + tabs.length) % tabs.length], true);
        });
      });
    }
  });
})();
